import React from 'react';
import { Box, Typography, makeStyles, Collapse } from '@material-ui/core';
import { ITemplateCategory } from '../../constants/templates';

const useStyles = makeStyles((theme) => ({
    subcategoryItem: {
        display: 'flex',
        alignItems: 'flex-start',
        padding: theme.spacing(1, 1.5, 1, 4),
        borderRadius: theme.spacing(1),
        cursor: 'pointer',
        transition: 'all 0.2s ease-in-out',
        gap: theme.spacing(1.5),
        '&:hover': {
            backgroundColor: theme.palette.action.hover,
            transform: 'scale(1.02)',
        },
    },
    selectedSidebarItem: {
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.primary.contrastText,
        '&:hover': {
            backgroundColor: theme.palette.primary.dark,
        },
    },
    sidebarIcon: {
        width: 24,
        height: 24,
        display: 'flex',
        alignItems: 'flex-start',
        justifyContent: 'center',
        flexShrink: 0,
        paddingTop: 2,
    },
    sidebarLabel: {
        wordBreak: 'break-word',
        overflowWrap: 'break-word',
        flex: 1,
        lineHeight: 1.4,
    },
}));

interface ISubcategoriesList {
    subcategories: ITemplateCategory[];
    selectedMenuOption: string;
    isExpanded: boolean;
    onSubcategoryClick: (subcategoryId: string) => void;
}

export const SubcategoriesList = ({
    subcategories,
    selectedMenuOption,
    isExpanded,
    onSubcategoryClick,
}: ISubcategoriesList) => {
    const classes = useStyles();

    const isSubcategorySelected = (subcategoryId: string) => {
        return selectedMenuOption === subcategoryId;
    };

    return (
        <Collapse in={isExpanded}>
            <Box>
                {subcategories.map((subcategory) => (
                    <Box
                        key={subcategory.id}
                        className={`${classes.subcategoryItem} ${
                            isSubcategorySelected(subcategory.id)
                                ? classes.selectedSidebarItem
                                : ''
                        }`}
                        onClick={() => onSubcategoryClick(subcategory.id)}
                        data-testid={`submenu-option-${subcategory.id}`}
                    >
                        <Box className={classes.sidebarIcon}>•</Box>
                        <Typography
                            variant="body2"
                            className={classes.sidebarLabel}
                        >
                            {subcategory.label}
                        </Typography>
                    </Box>
                ))}
            </Box>
        </Collapse>
    );
};
